import { auth } from './firebase.ts';
import type { CrossAppBackendTypes } from '../cross-app-backend/cross-app-backend.ts';

export async function crossAppBackendRequest<Name extends keyof CrossAppBackendTypes>(
  name: Name,
  args: CrossAppBackendTypes[Name]['request'],
): Promise<CrossAppBackendTypes[Name]['response']> {
  const token = await auth.currentUser?.getIdToken();
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  };

  const response:
    | { status: 'error'; error: string }
    | { status: 'success'; response: CrossAppBackendTypes[Name]['response'] } = await fetch('/api/crossapp/' + name, {
    method: 'POST',
    headers,
    body: JSON.stringify(args),
  })
    .then((r) => r.json())
    .catch((e) => {
      console.error(`Backend request to crossapp/${name} failed`, args, e);
      throw new Error(
        `Backend request to crossapp/${name} failed${e instanceof Error ? ` with error: ${e.message}` : ''}.`,
        { cause: e },
      );
    });

  if (response.status === 'error') {
    console.error(response);
    throw new Error(response.error);
  } else {
    return response.response;
  }
}
